import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { setCompany } from 'auth/actions';
import { getSubcompanies } from 'subcompanies/actions';

import Layout from 'components/layout';
import withTokenVerified from 'secured/hocs/withTokenVerified';

import { getIsLoading, getCompanies } from 'companies/selectors';
import { getCompany } from 'auth/selectors';

const states = Layout.StatesReadySwitch;

export default (Element, withSubcompany = true) => {
  class WithSelectedCompany extends PureComponent {
    static propTypes = {
      companies: PropTypes.object,
      company: PropTypes.object,
      isLoading: PropTypes.bool,
    };

    state = { view: states.LOADING };

    componentWillMount = () => {
      this.props.getSubcompanies(this.props.match.params.id);
    };

    componentWillReceiveProps = (nextProps) => {
      const companyId = this.props.match.params.id;

      // Theres companies and is not loading
      if (nextProps.companies && !nextProps.isLoading) {
        const company = nextProps.companies[companyId];

        // If no company found redirect to company selection
        if (!company) return this.setState({ view: states.SELECT_COMPANY });

        // If no company setted yet or different id, set the company
        if (!nextProps.company || company.id !== nextProps.company.id) {
          this.props.setCompany(company);
        }

        // If company and still loading, all ready!
        if (nextProps.company && this.state.view === states.LOADING) {
          return this.setState({ view: states.OK });
        }
      }
    };

    render = () => (
      <Layout.ReadySwitch
        Element={Element}
        state={this.state.view}
        companyId={this.props.company ? this.props.company.id : null}
        {...this.props}
      />
    );
  }

  const mapStateToProps = (state) => ({
    companies: getCompanies(state),
    company: getCompany(state),
    isLoading: getIsLoading(state),
  });

  const mapDispatchToProps = {
    getSubcompanies,
    setCompany,
  };

  return withTokenVerified(
    withRouter(connect(mapStateToProps, mapDispatchToProps)(WithSelectedCompany))
  );
};



// WEBPACK FOOTER //
// src/modules/secured/hocs/withCompanySelected.js